import utils from "@/utils/utils";
import axios from "axios";
let debug = false
//let serviceUrl = '/api/Service/Service.aspx'
let serviceUrl = '/Service/Service.aspx'

function Service(url, params, callback){
  let data = new URLSearchParams();
  //params["guid"] = '0849c42f236f7cb046a06d41832f1723';
  //params["jigou_guid"] = "d85a1481f8bda8c5aca6767c223a5ba9";
  for(let param in params){
    data.append(param, params[param]);
  }
  if(!debug){
    url = serviceUrl
  }
  axios.defaults.withCredentials = true;
  axios
    .post(url, data)
    .then(function (response){
      if(response.data.ErrorId != undefined){
        console.log(response.data);
        alert(response.data.ErrorMsg)
      }else{
        callback(response.data)
      }
    }
    )
    .catch(function (error) { // 请求失败处理
      console.log(error);
    });
}

function loadAllQue(Params,callback){
  let testUrl = '/static/json/que.json';
  Service(
    testUrl,
    {
      'module':'QueInfo',
      'action':'ALLQuery',
      'params': JSON.stringify(Params)
    },
    callback)
}

function loadQue(callback){
  let testUrl = '/static/json/que.json';
  let que_gid = utils.GetQueryString('gid');
  Service(
    testUrl,
    {
      'module':'QueInfo',
      'action':'Query',
      'params': JSON.stringify({que_gid: que_gid})
    },
    callback)
}

function updateQue(Params, callback){
  let testUrl = '/static/json/topic.json';
  let que_gid = utils.GetQueryString('gid');
  Params["que_gid"] = que_gid;
  Service(
    testUrl,
    {
      'module':'QueInfo',
      'action':'Update',
      'params': JSON.stringify(Params)
    },
  callback)
}

function loadTopics(Params, callback){
  let testUrl = '/static/json/topic.json';
  let que_gid = utils.GetQueryString('gid');
  Params["que_gid"] = que_gid;
  Service(
    testUrl,
    {
      'module':'Topic',
      'action':'Query',
      'params': JSON.stringify(Params)
    },
    callback)
}

function updateTopics(Params, callback){
  let testUrl = '/static/json/topic.json';
  let que_gid = utils.GetQueryString('gid');
  Params["que_gid"] = que_gid;
  Service(
    testUrl,
    {
      'module':'Topic',
      'action':'Update',
      'params': JSON.stringify(Params)
    },
  callback)
}

function loadResult(callback){
  let testUrl = '/static/json/record.json';
  let que_gid = utils.GetQueryString('gid');
  Service(
    testUrl,
    {
      'module':'QueRecord',
      'action':'Query',
      'params': JSON.stringify({que_gid: que_gid})
    },
    callback)
}

function loadReply(params, callback){
  let testUrl = '/static/json/reply.json';
  Service(
    testUrl,
    {
      'module':'Reply',
      'action':'Query',
      'params': JSON.stringify(params)
    },
    callback)
}

function UpdateReply(params, callback){
  let testUrl = '/static/json/reply.json';
  Service(
    testUrl,
    {
      'module':'Reply',
      'action':'Update',
      'params': JSON.stringify(params)
    },
    callback)
}

function loadQueCode(Params, callback){
  let testUrl = '/static/json/topic.json';
  let que_gid = utils.GetQueryString('gid');
  Params["que_gid"] = que_gid;
  Service(
    testUrl,
    {
      'module':'QueCode',
      'action':'Query',
      'params': JSON.stringify(Params)
    },
    callback)
}
//提交代码
function updateQueCode(Params, callback){
  let testUrl = '/static/json/topic.json';
  let que_gid = utils.GetQueryString('gid');
  Params["que_gid"] = que_gid;
  Service(
    testUrl,
    {
      'module':'QueCode',
      'action':'Update',
      'params': JSON.stringify(Params)
    },
    callback)
}

function loadUsecase(callback){
  let testUrl = '/static/json/topic.json';
  let que_gid = utils.GetQueryString('gid');
  Service(
    testUrl,
    {
      'module':'UseCase',
      'action':'Query',
      'params': JSON.stringify({que_gid: que_gid})
    },
    callback)
}

function updateUsecase(Params, callback){
  let testUrl = '/static/json/topic.json';
  let que_gid = utils.GetQueryString('gid');
  Params["que_gid"] = que_gid;
  Service(
    testUrl,
    {
      'module':'UseCase',
      'action':'Update',
      'params': JSON.stringify(Params)
    },
    callback)
}


function ExamFabu(Params, callback){
  let testUrl = '/static/json/topic.json';
  let exam_gid = utils.GetQueryString('exam_gid');
  let vip_gid = utils.GetQueryString('vip_gid');
  Params["exam_gid"] = exam_gid;
  Params["vip_gid"] = vip_gid;
  Service(
    testUrl,
    {
      'module':'ExamToQue',
      'action':'ExamFabu',
      'params': JSON.stringify(Params)
    },
    callback)
}


function ExamQuery(Params, callback){
  let testUrl = '/static/json/topic.json';
  let exam_gid = utils.GetQueryString('exam_gid');
  Params["gid"] = exam_gid;

  Service(
    testUrl,
    {
      'module':'Exam',
      'action':'Query',
      'params': JSON.stringify(Params)
    },
    callback)
}
//"exam_answer":[{"key":"06A0446EC82B4CE29AF07E159B0A48D8","value":"A"}]
function ExamFabuUpdate(Params, callback){
  let testUrl = '/static/json/topic.json';
  let exam_gid = utils.GetQueryString('exam_gid');
  let vip_gid = utils.GetQueryString('vip_gid');
  Params["exam_gid"] = exam_gid;
  Service(
    testUrl,
    {
      'module':'ExamToQue',
      'action':'ExamFabuUpdate',
      'vip_gid': vip_gid,
      'params': JSON.stringify(Params)
    },
    callback)
}

export default {
  loadAllQue,
  loadQue,
  updateQue,
  loadTopics,
  updateTopics,
  loadResult,
  loadReply,
  UpdateReply,
  loadQueCode,
  updateQueCode,
  loadUsecase,
  updateUsecase,
  ExamFabu,
  ExamQuery,
  ExamFabuUpdate
};
